<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Shto marimangë</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <form>
            <div class="col-12">
              <div class="white-background mb-30">
                <div class="form-group">
                  <label>Të dhënat e marimangës</label>
                  <input type="text" placeholder="Numri i regjistrimit" v-model="truck.registration_number" :class="{'is-invalid' : this.errors['registration_number'] }">
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="confirmation">
                <button type @click="addRequest">Shto</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";

export default {
  name: "AdminAddRequest",
  data: function() {
    return {
        errors: [],
      truck: {
            registration_number: '',
        }
      }
    },
  components: {
    AdminSidebar: AdminSidebar
  },
  methods: {
      invalid(value) {
      if(value && value !== '') {
        return false;
      }
      return true;
    },
    addRequest(e) {
      e.preventDefault();
      this.errors = [];
      if(this.invalid(this.truck.registration_number)) { this.errors['registration_number'] = true; }
      
      if(Object.keys(this.errors).length > 0) {
        return;
      }
      this.$store.dispatch("trucks/addTruck", this.truck);
    }
  },
  computed: {
    ...mapGetters({
    //   fullName: "requests/fullName",
    //   longitude: "requests/longitude",
    //   latitude: "requests/latitude",
    //   carBrand: "requests/carBrand",
    //   registrationNumber: "requests/registrationNumber",
    //   truckId: "requests/truckId",
    //   requestStatus: "requests/requestStatus",
    //   address: "requests/address",
    //   carColor: "requests/carColor",
    //   availableTrucks: "trucks/availableTrucks"
    })
  },
  beforeMount() {
    // this.$store.dispatch("trucks/getTrucksList");
    // this.$store.dispatch("requests/resetRequestState");
  }
};
</script>
